import { createSlice } from "@reduxjs/toolkit";

const globalContentSlice = createSlice({
  name: "globalContent",
  initialState: {
    data: null,
    callApi: false
  },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    }
  },
});

export const { setData } = globalContentSlice.actions;
export default globalContentSlice.reducer;
